import { createSlice } from '@reduxjs/toolkit';
import { VideoAgreementScreens } from './VideoAgreement.constants';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  currentScreen: VideoAgreementScreens.INTRODUCTION,
  docToSign: null,
};

const videoAgreementSlice = createSlice({
  name: 'videoAgreement',
  initialState,
  reducers: {
    setVideoAgreementState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetVideoAgreementState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setVideoAgreementState, resetVideoAgreementState } =
  videoAgreementSlice.actions;

export default videoAgreementSlice.reducer;
